/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const cartRouter = {
  path: '/cart',
  component: Layout,
  name: 'cart',
  redirect: '/cart',
  hidden: true,
  meta: {
    title: '购物车'
  },
  children: [
    {
      path: '/cart',
      component: () => import('@/views/cart/index'),
      name: 'cart',
      meta: { title: '全部搭配', affix: true, power: true }
    }
  ]
}

export default cartRouter
